import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { STATIC } from '../../lib/queryPresets';
import * as svc from '../../services/portal/portalInviteService';

const portalAccessKey = (contactId: string) => ['contact-portal-access', contactId];

export function useContactPortalAccess(contactId: string | undefined) {
  return useQuery({
    ...STATIC,
    queryKey: portalAccessKey(contactId ?? ''),
    queryFn: () => svc.contactHasPortalAccess(contactId!),
    enabled: !!contactId,
  });
}

interface InviteVars {
  contactId: string;
  /** Dossier depuis lequel on invite : nommé dans le mail. */
  dossierId?: string;
}

export function useInviteClient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ contactId, dossierId }: InviteVars) => svc.inviteClientToPortal(contactId, dossierId),
    onSuccess: (_, { contactId }) => {
      qc.invalidateQueries({ queryKey: portalAccessKey(contactId) });
    },
  });
}

export function useResendClientInvitation() {
  return useMutation({
    mutationFn: ({ contactId, dossierId }: InviteVars) => svc.resendClientInvitation(contactId, dossierId),
  });
}
